// ============================================
// ConverseTech Frontend - Radar Chart Component
// ============================================

import {
  Radar,
  RadarChart as RechartsRadar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
} from 'recharts';
import type { SkillBreakdown } from '@conversetech/shared';

interface RadarChartProps {
  skills: SkillBreakdown;
}

export default function RadarChart({ skills }: RadarChartProps) {
  const data = [
    { skill: 'Fluency', value: skills.fluency },
    { skill: 'Structure', value: skills.structure },
    { skill: 'Confidence', value: skills.confidence },
    { skill: 'Pressure', value: skills.pressure },
    { skill: 'Vocabulary', value: skills.vocabulary },
  ];

  return (
    <div className="w-full h-48 sm:h-64">
      <ResponsiveContainer width="100%" height="100%">
        <RechartsRadar data={data} margin={{ top: 10, right: 20, bottom: 10, left: 20 }}>
          <PolarGrid stroke="#e5e7eb" />
          <PolarAngleAxis
            dataKey="skill"
            tick={{ fill: '#6b7280', fontSize: 10 }}
            className="text-[10px] sm:text-xs"
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 100]}
            tick={{ fill: '#9ca3af', fontSize: 8 }}
            tickCount={4}
          />
          <Radar
            name="Skills"
            dataKey="value"
            stroke="#3b82f6"
            fill="#3b82f6"
            fillOpacity={0.4}
          />
        </RechartsRadar>
      </ResponsiveContainer>
    </div>
  );
}
